module.exports = __webpack_public_path__ + "img/btn-intro-movie.3daa22ec.jpg";